import { Avatar, HStack, SkeletonCircle, SkeletonText, Text } from '@chakra-ui/react';

interface CompanyHeaderProps {
  company: any
}

export default function CompanyHeader({ company }: CompanyHeaderProps) {
  const isLoaded = !!company;
  return (
    <HStack
      ml="auto"
      spacing="10px"
    >
      <SkeletonCircle isLoaded={isLoaded}>
        <Avatar 
          bg="green.100"
          color="green.800"
          size="sm" 
          src={company?.logo} 
          name={company?.name} 
        />
      </SkeletonCircle>
      
      <SkeletonText noOfLines={1} isLoaded={isLoaded}>
        <Text 
          as="span" 
          color="#0A0D14"
          fontWeight={500}
        >
          {company?.name}
        </Text>
      </SkeletonText>
    </HStack>
  )
}
